import dynamic from 'next/dynamic'

import { useRouter } from 'next/router'

import { useCallback, useState } from 'react'

import ButtonBlue from '../../../../../../components/ui/button/_color/_blue'

import { useAppSelector } from '../../../../../../store/hooks'

import { selectedAuthStatus, LoginStatuses } from '../../../../../../store/reducers/users'

import styles from './styles.module.scss'

import WorthRelyingOnLogo from './icons/worth-btc-logo.svg'
import ArrowIcon from './icons/arrowIcon.svg'
import BorderIcon from './icons/border.svg'
import TrianglesImg from './icons/trinagles.svg'
import BorderIconMobile from './icons/border-mobile.svg'
import TrianglesImgMobile from './icons/triangles-mobile.svg'
import { useTranslation } from 'utils/use-translation'

const LoginForm = dynamic(() => import('../../../../../../components/ui/header/components/popup-login-form'), {
  ssr: false,
})

const POPUP_TYPE_LOANS = 'loans'

export default function CoinWalletGetWallet({ pageCurrency }) {
  const { t } = useTranslation()
  const [isOpenLoginBlock, setIsOpenLoginBlock] = useState(false)

  const authStatus = useAppSelector(selectedAuthStatus)
  const router = useRouter()

  const handleClosePopup = useCallback(() => {
    setIsOpenLoginBlock(false)
  }, [])

  const goToWallets = async () => {
    if (authStatus === LoginStatuses.LOGIN) {
      await router.push({
        pathname: '/account/wallets',
      })
    } else {
      setIsOpenLoginBlock(true)
    }
  }
  return (
    <>
      <div className={styles.getWallet}>
        <img className={styles.borderLeft} src={BorderIcon} alt="border left icon" />
        <img className={styles.borderRight} src={BorderIcon} alt="border right icon" />
        <div className={styles.getWallet__content}>
          <div className={styles.title}>
            <img className={styles.title__preImg} src={TrianglesImg} alt="triangles image" />
            <img
              className={styles.title__coinImg}
              src={pageCurrency.worthRelyingOnLogoUrl || WorthRelyingOnLogo}
              alt="coin logo image"
            />
            <p>
              {t('get_your_secure')}{' '}
              <span>
                {pageCurrency.ticker} ({pageCurrency.name})
              </span>{' '}
              {t('wallet_right_now')}
            </p>
          </div>
          <img className={styles.arrowImg} src={ArrowIcon} alt="arrow icon" />
        </div>
        <ButtonBlue onClick={goToWallets} className={styles.btn} bordered>{t('create_new_wallet')}</ButtonBlue>
      </div>

      <div className={styles.getWalletMobile}>
        <img className={styles.borderLeft} src={BorderIconMobile} alt="border left icon" />
        <img className={styles.borderRight} src={BorderIconMobile} alt="border right icon" />
        <div className={styles.title}>
          <img className={styles.title__preImg} src={TrianglesImgMobile} alt="triangles image" />
          <img
            className={styles.title__coinImg}
            src={pageCurrency.worthRelyingOnLogoUrl || WorthRelyingOnLogo}
            alt="coin logo"
          />
          <p>
            {pageCurrency.ticker} ({pageCurrency.name})
          </p>
        </div>
        <p>{t('get_secure_wallet')}</p>
        <ButtonBlue className={styles.btn}>{t('create_new_wallet')}</ButtonBlue>
      </div>
      {isOpenLoginBlock && <LoginForm isWallet={false} onCloseForm={handleClosePopup} type={POPUP_TYPE_LOANS} />}
    </>
  )
}
